import React, { useEffect, useState } from 'react';

const MyProfile: React.FC = () => {
    const [profile, setProfile] = useState({
        username: '',
        role: '',
        phone: '',
        email: '',
        password: '' // Only for input
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/users/me', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (response.ok) {
                const data = await response.json();
                setProfile({ ...data, password: '' });
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            console.log("Updating profile with:", profile);
            const token = localStorage.getItem('token');
            const response = await fetch('/api/users/me', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    phone: profile.phone,
                    email: profile.email,
                    password: profile.password || undefined // Send undefined if empty to skip update
                })
            });

            if (response.ok) {
                alert('정보가 수정되었습니다.');
                fetchProfile(); // Refresh
            } else {
                alert('수정 실패');
            }
        } catch (error) {
            console.error(error);
            alert('오류 발생');
        }
    };

    if (loading) return <div>로딩 중...</div>;

    return (
        <div style={{ maxWidth: '600px', margin: '40px auto', padding: '30px', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
            <h2 style={{ marginBottom: '20px', borderBottom: '2px solid #f0f0f0', paddingBottom: '10px' }}>내 정보 수정</h2>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>아이디 (변경 불가)</label>
                    <input type="text" value={profile.username} disabled style={{ width: '100%', padding: '10px', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '4px' }} />
                </div>
                <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>권한</label>
                    <input type="text" value={profile.role === 'admin' ? '관리자' : '영업 담당(직원)'} disabled style={{ width: '100%', padding: '10px', backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '4px' }} />
                </div>

                <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>연락처</label>
                    <input
                        type="text"
                        value={profile.phone || ''}
                        onChange={e => setProfile({ ...profile, phone: e.target.value })}
                        placeholder="010-0000-0000"
                        style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
                    />
                </div>

                <div>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>이메일</label>
                    <input
                        type="email"
                        value={profile.email || ''}
                        onChange={e => setProfile({ ...profile, email: e.target.value })}
                        placeholder="example@email.com"
                        style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}
                    />
                </div>

                <div style={{ marginTop: '10px', padding: '15px', backgroundColor: '#fff8e1', borderRadius: '4px', border: '1px solid #ffeeba' }}>
                    <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#856404' }}>비밀번호 변경 (선택사항)</label>
                    <input
                        type="password"
                        value={profile.password}
                        onChange={e => setProfile({ ...profile, password: e.target.value })}
                        placeholder="변경할 경우에만 입력하세요"
                        autoComplete="new-password"
                        style={{ width: '100%', padding: '10px', border: '1px solid #ced4da', borderRadius: '4px' }}
                    />
                </div>

                <button
                    type="submit"
                    style={{
                        marginTop: '10px', padding: '12px', backgroundColor: '#007bff', color: 'white',
                        border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: 'bold', cursor: 'pointer'
                    }}
                >
                    저장하기
                </button>
            </form>
        </div>
    );
};

export default MyProfile;
